/* FlauschFreude: gemeinsame Funktionen für alle Seiten
   Cookie-Einwilligung, UTM, Mobil-Menü, Fortschrittsbalken, Nach-oben- und Kontakt-Button,
   Kopieren, Bestätigungsdialog, Formulare, FAQ-Suche, Druck. */
(() => {
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const store = {
    get: (k, s = localStorage) => { try { return JSON.parse(s.getItem(k)); } catch (e) { return null; } },
    set: (k, v, s = localStorage) => { try { s.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  const root = document.documentElement;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  setTimeout(() => root.classList.add("ready"), 1200);

  // Die Seite ist immer hell, es gibt keinen Dunkel-Schalter mehr.

  // ---------- Bestätigungsdialog ----------
  const dlg = document.createElement("dialog");
  dlg.className = "modal";
  dlg.innerHTML = '<form method="dialog"><h2 data-m-title></h2><p data-m-text></p><div class="m-actions"><button value="no" class="btn-soft" data-m-no>Abbrechen</button><button value="yes" class="btn-solid" data-m-yes>OK</button></div></form>';
  document.body.appendChild(dlg);
  window.snugConfirm = (title, text, yes = "Ja", no = "Abbrechen") => new Promise((res) => {
    $("[data-m-title]", dlg).textContent = title; $("[data-m-text]", dlg).textContent = text;
    $("[data-m-yes]", dlg).textContent = yes; $("[data-m-no]", dlg).textContent = no;
    dlg.returnValue = "";
    dlg.addEventListener("close", () => res(dlg.returnValue === "yes"), { once: true });
    dlg.showModal(); $("[data-m-no]", dlg).focus();
  });
  dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close("no"); });

  // ---------- Cookie-Einwilligung + UTM ----------
  // UTM-Parameter (Herkunft von TikTok, Instagram usw.) werden nur mit Einwilligung in Statistik gespeichert.
  // In Shopify: als Warenkorb-Attribute an die Bestellung hängen.
  const utm = {};
  new URLSearchParams(location.search).forEach((v, k) => { if (/^utm_(source|medium|campaign|term|content)$/.test(k)) utm[k] = v.slice(0, 100); });
  const keepUtm = () => {
    const c = store.get("snug-consent");
    if (!c || !c.stats) return;
    if (Object.keys(utm).length) store.set("snug-utm", Object.assign({}, utm, { landed: new Date().toISOString().slice(0, 10) }), sessionStorage);
    window.snugUTM = store.get("snug-utm", sessionStorage) || {};
  };
  const banner = document.createElement("section");
  banner.className = "cookie"; banner.setAttribute("aria-label", "Cookie-Einstellungen"); banner.hidden = true;
  banner.innerHTML =
    '<h2>Cookies und Datenschutz</h2>' +
    '<p>Warenkorb und Einstellungen speichern wir immer. Mit deiner Zustimmung messen wir auch, wie die Seite genutzt wird. <a href="/pages/datenschutz">Datenschutz</a></p>' +
    '<div class="c-more" hidden><label class="c-row"><input type="checkbox" checked disabled> <span><b>Notwendig</b> Warenkorb, Design-Einstellung, diese Auswahl</span></label>' +
    '<label class="c-row"><input type="checkbox" data-c-stats> <span><b>Statistik</b> Besucherzahlen und Herkunft (z. B. TikTok)</span></label></div>' +
    '<div class="c-actions"><button class="btn-soft" data-c-only>Nur notwendige</button><button class="btn-soft" data-c-all>Alle akzeptieren</button></div>' +
    '<button class="c-link" data-c-set>Einstellungen</button>';
  document.body.appendChild(banner);
  const saveConsent = (stats) => {
    store.set("snug-consent", { stats, date: new Date().toISOString().slice(0, 10) });
    banner.hidden = true; keepUtm();
  };
  const openBanner = () => {
    const c = store.get("snug-consent");
    $("[data-c-stats]", banner).checked = !!(c && c.stats);
    banner.hidden = false; $("button", banner).focus();
  };
  $("[data-c-only]", banner).addEventListener("click", () => saveConsent(false));
  $("[data-c-all]", banner).addEventListener("click", () => saveConsent(true));
  $("[data-c-set]", banner).addEventListener("click", (e) => {
    const more = $(".c-more", banner);
    if (more.hidden) { more.hidden = false; e.currentTarget.textContent = "Auswahl speichern"; }
    else saveConsent($("[data-c-stats]", banner).checked);
  });
  $$("[data-cookie-settings]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); if (window.SNUG_SHOPIFY) { if (window.privacyBanner) window.privacyBanner.showPreferences(); } else openBanner(); }));
  // In Shopify zeigt Shopify das Cookie-Banner (Einstellungen > Datenschutz für Kunden), UTM erfasst Shopify selbst
  if (!window.SNUG_SHOPIFY) { if (!store.get("snug-consent")) banner.hidden = false; else keepUtm(); }

  // ---------- Mobil-Menü ----------
  const menuBtn = $("[data-menu]"), menu = $("[data-menu-panel]");
  if (menuBtn && menu) {
    const setMenu = (open) => {
      menuBtn.setAttribute("aria-expanded", open); menu.hidden = !open;
      document.body.classList.toggle("menu-open", open);
      if (open) $("a", menu).focus();
    };
    menuBtn.addEventListener("click", () => setMenu(menuBtn.getAttribute("aria-expanded") !== "true"));
    $$("a", menu).forEach((a) => a.addEventListener("click", () => setMenu(false)));
    addEventListener("keydown", (e) => { if (e.key === "Escape" && !menu.hidden) { setMenu(false); menuBtn.focus(); } });
    matchMedia("(min-width: 900px)").addEventListener("change", (m) => m.matches && setMenu(false));
  }

  // ---------- Fortschrittsbalken und Linie unter der Kopfzeile ----------
  // Die schwebenden Knöpfe (Fragen, nach oben) sind weg: am Handy liegt dort die Kaufleiste.
  const nav = $(".nav");
  let tick = false;
  const onScroll = () => {
    tick = false;
    const max = document.documentElement.scrollHeight - innerHeight;
    if (nav) nav.style.setProperty("--p", max > 0 ? Math.min(1, scrollY / max) : 0);
    document.body.classList.toggle("scrolled", scrollY > 8);
  };
  addEventListener("scroll", () => { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  // ---------- Set direkt aus einem Abschnitt wählen (z. B. "Pärchen-Set wählen") ----------
  $$("[data-pick-set]").forEach((b) => b.addEventListener("click", () => {
    const bundle = $('.bundle[data-qty="' + b.dataset.pickSet + '"]');
    if (bundle) bundle.click();
    const buy = $("#kaufen");
    if (buy) scrollTo({ top: buy.getBoundingClientRect().top + scrollY - 70, behavior: reduce ? "auto" : "smooth" });
  }));

  // ---------- Kopieren ----------
  $$("[data-copy]").forEach((b) => b.addEventListener("click", async () => {
    const label = b.textContent;
    try { await navigator.clipboard.writeText(b.dataset.copy); b.textContent = "Kopiert"; }
    catch (e) { b.textContent = "Bitte markieren"; }
    b.classList.add("done");
    setTimeout(() => { b.textContent = label; b.classList.remove("done"); }, 1800);
  }));

  // ---------- Formulare: Fehler pro Feld, Laden, Erfolg ----------
  // data-form="kontakt" | "widerruf". In Shopify an das Kontaktformular bzw. die Widerrufsfunktion anbinden.
  const fieldError = (f, msg) => {
    const box = f.closest(".field") || f.parentElement;
    let el = $(".f-err", box);
    if (!el) { el = document.createElement("p"); el.className = "f-err"; el.id = (f.id || "f") + "-err"; box.appendChild(el); }
    el.textContent = msg || ""; f.setAttribute("aria-invalid", !!msg);
    if (msg) f.setAttribute("aria-describedby", el.id); else f.removeAttribute("aria-describedby");
  };
  const msgFor = (f) => {
    if (f.type === "checkbox") return "Bitte bestätige das.";
    if (!f.value.trim()) return "Bitte ausfüllen.";
    if (f.type === "email") return "Bitte gib eine gültige E-Mail-Adresse ein, zum Beispiel name@beispiel.de.";
    return "Bitte prüfe deine Eingabe.";
  };
  $$("form[data-form]").forEach((form) => {
    const fields = $$("input,textarea,select", form).filter((f) => f.required || f.pattern);
    fields.forEach((f) => f.addEventListener(f.type === "checkbox" ? "change" : "blur", () => fieldError(f, f.checkValidity() && (f.type === "checkbox" || f.value.trim()) ? "" : msgFor(f))));
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const bad = fields.filter((f) => !f.checkValidity() || (f.type !== "checkbox" && !f.value.trim()));
      fields.forEach((f) => fieldError(f, bad.includes(f) ? msgFor(f) : ""));
      const status = $("[data-form-status]", form);
      if (bad.length) {
        status.className = "f-status err";
        status.textContent = bad.length === 1 ? "Ein Feld fehlt noch." : bad.length + " Felder fehlen noch.";
        bad[0].focus(); return;
      }
      if (form.dataset.confirm) {
        const [t, x, y] = form.dataset.confirm.split("|");
        if (!(await window.snugConfirm(t, x, y))) return;
      }
      if (form.dataset.real) { form.submit(); return; }
      const btn = $("button[type=submit]", form);
      btn.classList.add("loading"); btn.disabled = true; status.className = "f-status"; status.textContent = "";
      await new Promise((r) => setTimeout(r, 900));
      btn.classList.remove("loading"); btn.disabled = false;
      form.classList.add("sent");
      const ok = $("[data-form-ok]", form.parentElement);
      if (ok) { ok.hidden = false; ok.focus(); }
    });
  });

  // ---------- FAQ-Suche ----------
  const q = $("[data-faq-search]");
  if (q) {
    const items = $$(".faq-list details"), none = $("[data-faq-none]");
    q.addEventListener("input", () => {
      const v = q.value.trim().toLowerCase();
      let hits = 0;
      items.forEach((d) => {
        const hit = !v || d.textContent.toLowerCase().includes(v);
        d.hidden = !hit; if (hit) hits++;
        d.open = !!v && hit && hits <= 2;
      });
      none.hidden = hits > 0;
    });
  }

  // ---------- Bilder: ruhiger Platzhalter, bis sie geladen sind ----------
  const markImg = (img) => {
    if (img.complete && img.naturalWidth) return;
    const box = img.parentElement; box.classList.add("is-loading");
    const done = () => box.classList.remove("is-loading");
    img.addEventListener("load", done, { once: true }); img.addEventListener("error", done, { once: true });
  };
  $$("img[loading=lazy]").forEach(markImg);
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.querySelectorAll && $$("img[loading=lazy]", n).forEach(markImg)))).observe(document.body, { childList: true, subtree: true });

  // ---------- Bewegung (nur ohne "Bewegung reduzieren") ----------
  if (!reduce) {
    // Überschriften: Wörter steigen aus einer Maske auf. H1 beim Laden, H2 wenn sie ins Bild kommen.
    // Wörter einzeln einpacken; hervorgehobene Wörter (.mark mit Unterstreichung) bleiben ganz erhalten
    const split = (h) => {
      if (h.dataset.split) return;
      h.dataset.split = "1";
      h.setAttribute("aria-label", h.textContent.trim());
      let i = 0;
      [...h.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(" ")); return; }
            const s = document.createElement("span");
            s.className = "w"; s.setAttribute("aria-hidden", "true");
            s.innerHTML = '<i style="--i:' + i++ + '"></i>'; s.firstChild.textContent = part;
            frag.appendChild(s);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) {
          n.setAttribute("aria-hidden", "true"); n.classList.add("w-el"); n.style.setProperty("--i", i++);
        }
      });
    };
    const h1 = $(".panel h1");
    if (h1) { split(h1); h1.classList.add("rise"); }
    const heads = $$(".sec-head h2,.legal h1,.kat-top h1");
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target); e.target.classList.add("rise");
      }), { rootMargin: "0px 0px -12% 0px" });
      heads.forEach((h) => {
        split(h);
        // Schon beim Laden sichtbar: sofort zeigen, nicht auf den Beobachter warten
        if (h.getBoundingClientRect().top < innerHeight) { h.classList.add("rise"); return; }
        h.classList.add("will-rise"); io.observe(h);
      });

      // Karten und Kacheln gleiten beim Scrollen leicht nach oben. Nur was noch unter dem Bildrand liegt,
      // wird dafür kurz versteckt; alles andere ist sofort sichtbar.
      const io2 = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        io2.unobserve(e.target); e.target.classList.add("in-view");
        e.target.classList.remove("will-grow");
      }), { rootMargin: "0px 0px -8% 0px" });
      $$(".reveal").forEach((el) => {
        if (el.getBoundingClientRect().top < innerHeight) { el.classList.add("in-view"); return; }
        el.classList.add("pre");
        if (el.matches("[data-grow]")) el.classList.add("will-grow");
        io2.observe(el);
      });
    } else $$(".reveal").forEach((el) => el.classList.add("in-view"));

  }


  // Shopify meldet erfolgreich gesendete Formulare über die Adresse
  if (/(customer|contact)_posted=true/.test(location.search)) $$("form[data-form]").forEach((f) => { const ok = $("[data-form-ok]", f.parentElement); if (ok) { f.classList.add("sent"); ok.hidden = false; } });

  // ---------- Druck: alle Antworten aufklappen ----------
  let opened = [];
  addEventListener("beforeprint", () => { opened = $$("details:not([open])"); opened.forEach((d) => (d.open = true)); });
  addEventListener("afterprint", () => opened.forEach((d) => (d.open = false)));
})();
